module.exports = __webpack_public_path__ + "static/media/badge-icon.f1f26363.svg";